import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/guards/ProtectedRoute";
import SpinnerOverlay from "@/components/ui/SpinnerOverlay";
import { PublicRoutes } from "@/routes/PublicRoutes";
import { ProtectedRoutes } from "@/routes/ProtectedRoutes";
import { AuthRoutes } from "@/routes/AuthRoute";
import { NotFoundRoute } from "@/routes/NotFoundRoute";
import {
  ProtectedFullLayout,
  PublicNavbarOnlyLayout,
  ProtectedNoChromeLayout,
  PublicLayout,
} from "@layouts/index";
import { MainLayout } from "@layouts/MainLayout";

const MCQTest = lazy(() => import("@/pages/Courses/MCQs/MCQTest/MCQTest"));
const MockInterview = lazy(() => import("@/pages/MockInterview/MockInterview"));
const FAQ = lazy(() => import("@/pages/PublicPages/FAQ/FAQ"));


export function AppContent() {
  return (
    <MainLayout>
      <Suspense fallback={<SpinnerOverlay />}>
        <Routes>
          {/* Public shell */}
          <Route element={<PublicLayout />}>{PublicRoutes}</Route>

          {/* Public navbar only */}
          <Route element={<PublicNavbarOnlyLayout />}>
            {AuthRoutes}
            <Route path="/faqs" element={<FAQ />} />
          </Route>

          {/* Protected wrapper */}
          <Route element={<ProtectedRoute />}>
            {/* Protected full layout */}
            <Route element={<ProtectedFullLayout />}>{ProtectedRoutes}</Route>

            {/* Protected no chrome */}
            <Route element={<ProtectedNoChromeLayout />}>
              <Route path="/mock-interview/:id" element={<MockInterview />} />
              <Route path="/mcq-test/:testId" element={<MCQTest />} />
            </Route>
          </Route>

          {/* 404 fallback */}
          {NotFoundRoute}
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
